import {
  IntakeAnswersSchema,
  MerchantSetupProductSchema,
  MerchantSetupProgressSchema,
} from "@redotech/redo-onboarding-db-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const submitMerchantSetupIntake = {
  name: "submitMerchantSetupIntake" as const,
  input: z.object({
    product: MerchantSetupProductSchema,
    answers: IntakeAnswersSchema,
  }),
  output: zExt.filterToValid(MerchantSetupProgressSchema),
};
